export default {
  labels: {
    card: 'Kreditkort',
    bank_account: 'Bankkonto',
  },
  alerts: {
    payments_not_configured:
      'Betalinger er ikke konfigureret endnu. Kontakt din udbyder for at aktivere betalinger, og vend derefter tilbage til dette trin.',
  },
  buttons: {
    change_payment_method: 'Skift betalingsmetode',
    save_payment_info: 'Gem betalingsoplysninger',
  },
  toasts: {
    failed_to_init_payment_setup: 'Betalingsopsætningen kunne ikke startes. Genindlæs siden',
    successfully_saved_payment_method: 'Betalingsoplysningerne blev gemt',
  },
};
